import { render, staticRenderFns } from "./addOrUpdate.vue?vue&type=template&id=00bdb848&scoped=true&"
import script from "./addOrUpdate.vue?vue&type=script&lang=js&"
export * from "./addOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bdb848",
  null
  
)

export default component.exports